module.exports = __webpack_public_path__ + "static/media/assistive-listening-systems.c5e1885a.svg";